// extracted by mini-css-extract-plugin
export default {"form":"SliderForm_form__eKyH8","formGroup":"SliderForm_formGroup__D2wBk","radioGroup":"SliderForm_radioGroup__zqx-6","submitButton":"SliderForm_submitButton__glukn"};